import { render, staticRenderFns } from "./FormInteresse.vue?vue&type=template&id=97ab9c26&scoped=true&"
import script from "./FormInteresse.vue?vue&type=script&lang=js&"
export * from "./FormInteresse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ab9c26",
  null
  
)

export default component.exports